import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbortError } from '@shared/use-cases';

@Injectable({ providedIn: 'root' })
export class AbortableHttp {
  public toPromise<T>(observable: Observable<T>, signal?: AbortSignal): Promise<T> {
    if (signal?.aborted) return Promise.reject(new AbortError());

    return new Promise<T>((resolve, reject) => {
      const subscription = observable.subscribe({ next: resolve, error: reject });

      if (!signal) return;

      const onAbort = () => {
        subscription.unsubscribe();
        reject(new AbortError());
      };

      signal.addEventListener('abort', onAbort, { once: true });
    });
  }
}
